import {
    IClienteCompleto,
    IClienteConta,
} from "../../../Interfaces/Geral/Cliente/IClienteSimples";
import {
    ClienteInterface,
    ICliente,
    IClienteEmLoteFilter,
    IClienteFilter,
    IClienteSimples,
    IComunicarClienteEmLoteBody,
    ListarClientesEmLoteResponse,
    ListarClientesResponse,
} from "../../../Interfaces/Geral/GestaoClientes/GestaoClientesInterfaces";
import Axios from "../../Config/API";
import Service from "../../Service";

export function ListarClientesService(
    page: number,
    idTipoCaso: number,
    filter: IClienteFilter,
    flPaginada?: boolean
) {
    return Service(
        Axios.post<ListarClientesResponse>(
            `/home/clientes/listarclientes?Pagina=${page}&idTipoCaso=${idTipoCaso}&flPaginada=${flPaginada}`,
            filter
        )
    );
}

export function ListarClientesVendasService(filtro: string) {
    return Service(
        Axios.post<Array<ClienteInterface>>(
            `/home/clientes/listarclientesvendas?filtro=${filtro}`
        )
    );
}

export function ListarClientesRegistraVendaService(
    page: number,
    filter: IClienteFilter
) {
    return Service(
        Axios.post<ListarClientesResponse>(
            `/home/clientes/listarclientesregistrarvenda?Pagina=${page}`,
            filter
        )
    );
}
export async function ListarClienteComunicadoEmLoteService(
    requestBody: IClienteEmLoteFilter
) {
    return Service(
        Axios.post<ListarClientesEmLoteResponse>(
            `/home/clienteemlote/listarclientecomunicadoemlote`,
            requestBody
        )
    );
}
export async function ListarContaSimplesService() {
    return Service(
        Axios.post<Array<IClienteSimples>>(`/home/clientes/listarcontasimples`)
    );
}

export function GetClienteService(idConta: number) {
    return Service(
        Axios.get<ICliente>(`/home/clientes/getcliente?idConta=${idConta}`)
    );
}

export function GetClienteCompletoService(idConta: number) {
    return Service(
        Axios.get<IClienteCompleto>(
            `/home/clientes/getcliente?idConta=${idConta}`
        )
    );
}

export function GetClientePorNomeOuEmailService(nomeEmail: string) {
    return Service(
        Axios.get<Array<IClienteConta>>(
            `/home/contas/getcontanomeemail?nomeEmail=${nomeEmail}`
        )
    );
}

export function AtualizarClienteService(
    requestBody: IClienteCompleto,
    atualizarUAU: boolean
) {
    return Service(
        Axios.put(
            `/home/clientes/atualizarcliente?atualizarUAU=${atualizarUAU}`,
            requestBody
        )
    );
}

export function EnviarFormularioEmailServices(
    idFormulario: number,
    idConta: number,
    idUnidade: number,
    idDocumentoTemplate: number
) {
    return Axios.get(
        `/home/atendimentos/enviarformularioemail?ID_FORMULARIO=${idFormulario}&idConta=${idConta}&idUnidade=${idUnidade}&idDocTemp=${idDocumentoTemplate}`
    );
}

export function ComunicarClienteEmLoteService(
    tipoComunicacao: "Email" | "WhatsApp" | "SMS",
    requestBody: IComunicarClienteEmLoteBody,
    idEmailConta?: number
) {
    return Service(
        Axios.post(
            `/home/clienteemlote/comunicarclienteemlote?TipoComunicacao=${tipoComunicacao}&idEmailConta=${idEmailConta}`,
            requestBody
        )
    );
}

export function ListarDocumentoTemplateService() {
    return Service(Axios.get(`/home/clienteemlote/listardocumentotemplate`));
}
